import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
  active?: boolean;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  onFilter?: (category: string) => void;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, onFilter }) => {
  return (
    <Breadcrumb className="blog-breadcrumbs">
      {items.map((item, index) => (
        <Breadcrumb.Item
          key={index}
          active={item.active}
          onClick={() => !item.active && onFilter && onFilter(item.label)}
          className={!item.active ? 'clickable' : ''}
        >
          {item.path ? (
            <Link to={item.path}>{item.label}</Link>
          ) : (
            item.label
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs; 